module.exports = __webpack_public_path__ + "img/1440.5a5e631f.jpg";